import type { ID } from '@octopus-do/octopus-project-core'
import axios from 'axios'

// The one place that knows how octopus-sync is addressed and authenticated:
// the same token header as the project calls, plus the share tokens of a
// project when the call is made on behalf of a viewer.

const baseURL = import.meta.env.VITE_SYNC_HTTP_URL

/** A call under the token of the current user. */
export const syncClient = () =>
  axios.create({
    baseURL,
    headers: {
      'X-Auth-Token': localStorage.getItem('token'),
    },
  })

/** A call with the access of the viewer of a project: export link or password. */
export const syncProjectClient = (projectId: ID) =>
  axios.create({
    baseURL,
    headers: {
      'X-Auth-Token': localStorage.getItem('token'),
      'X-Export-Token': localStorage.getItem('export_token'),
      'X-Password-Token': localStorage.getItem(`pw_${projectId}`),
    },
  })
